// extracted by mini-css-extract-plugin
export default {"main":"bread-crumbs_main__y+QA8","mainActive":"bread-crumbs_mainActive__r4pXr","crumbs":"bread-crumbs_crumbs__gnHR+","crumbsActiveTitle":"bread-crumbs_crumbsActiveTitle__8zT4k"};